var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPouchdb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272.833,
    height: 351.571,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.997 0L0 97.532l57.353 54.113L20.09 218.07l75.823 133.5h82.95l76.148-133.5-37.586-66.425 55.41-54.113L254.593 0l-77.997 103.878h-78.09z",
    fill: "#6ccb94",
    fillOpacity: 0.996
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.09 218.07l37.262-66.425 80.028 66.426z",
    fill: "#5dbd85",
    fillOpacity: 0.996
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.353 151.646l80.028 66.426L98.505 103.88z",
    fill: "#64c48c",
    fillOpacity: 0.996
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.01 218.07l-37.587-66.425-80.04 66.426z",
    fill: "#6ecc95",
    fillOpacity: 0.996
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.912 351.57h82.95l-41.48-133.5z",
    fill: "#5ebe86",
    fillOpacity: 0.996
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.423 151.646l-80.04 66.426 39.213-114.192z",
    fill: "#76d29c",
    fillOpacity: 0.996
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.593 0l18.238 97.533-55.408 54.113-40.828-47.767z",
    fill: "#74d09b",
    fillOpacity: 0.996
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.38 218.07l41.483 133.5 76.147-133.5z",
    fill: "#64c48c",
    fillOpacity: 0.996
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.38 218.07L95.9 351.57l-75.81-133.5z",
    fill: "#58b880",
    fillOpacity: 0.996
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.997 0L0 97.534l57.353 54.113 41.152-47.767z",
    fill: "#5fbf87",
    fillOpacity: 0.996
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M137.38 218.07l39.215-114.19h-78.09z",
    fill: "#6ecc95",
    fillOpacity: 0.996
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPouchdb);
export default __webpack_public_path__ + "static/media/pouchdb.f72b5e93db1795e95e31fadb6ee5ab1c.svg";
export { ForwardRef as ReactComponent };